export default "__VITE_ASSET__G8R_s0zV__"